import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'aos/dist/aos.css';
import 'swiper/css';
import 'swiper/css/pagination';
import 'glightbox/dist/css/glightbox.min.css';
import './App.css';

// Import JavaScript libraries
import AOS from 'aos';
import GLightbox from 'glightbox';
import { Swiper } from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';
import PureCounter from '@srexi/purecounterjs';
import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';

// Import components
import Header from './components/Header.jsx';
import Home from './components/Home.jsx';
import Footer from './components/Footer.jsx';
import ScrollTop from './components/ScrollTop.jsx';
import Preloader from './components/Preloader.jsx';
import ServiceDetails from './components/ServiceDetails.jsx';
import ProductDetail from './components/ProductDetail.jsx';

function App() {
  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 600,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    });

    // Initialize GLightbox
    GLightbox({
      selector: '.glightbox'
    });

    // Initialize PureCounter
    new PureCounter();

    const isotopeContainer = document.querySelector('.isotope-container');
    if (isotopeContainer) {
      const isotope = new Isotope(isotopeContainer, {
        itemSelector: '.portfolio-item',
        layoutMode: 'masonry'
      });

      imagesLoaded(isotopeContainer).on('progress', () => {
        isotope.layout();
      });

      // Portfolio filters
      const portfolioFilters = document.querySelectorAll('.portfolio-filters li');
      portfolioFilters.forEach(filter => {
        filter.addEventListener('click', () => {
          portfolioFilters.forEach(f => f.classList.remove('filter-active'));
          filter.classList.add('filter-active');
          
          const filterValue = filter.getAttribute('data-filter');
          isotope.arrange({ filter: filterValue });
        });
      });
    }

    // Initialize Swiper
    const swiper = new Swiper('.init-swiper', {
      modules: [Pagination, Autoplay],
      loop: true,
      speed: 600,
      autoplay: {
        delay: 5000,
      },
      slidesPerView: 'auto',
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 40
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 20
        }
      }
    });

    // Mobile nav toggle
    const mobileNavToggle = document.querySelector('.mobile-nav-toggle');
    if (mobileNavToggle) {
      mobileNavToggle.addEventListener('click', () => {
        document.body.classList.toggle('mobile-nav-active');
        mobileNavToggle.classList.toggle('bi-list');
        mobileNavToggle.classList.toggle('bi-x');
      });
    }

    // Hide mobile nav on same-page/hash links
    document.querySelectorAll('#navmenu a').forEach(navmenu => {
      navmenu.addEventListener('click', () => {
        if (document.querySelector('.mobile-nav-active')) {
          document.body.classList.remove('mobile-nav-active');
          mobileNavToggle.classList.add('bi-list');
          mobileNavToggle.classList.remove('bi-x');
        }
      });
    });

    // Toggle mobile nav dropdowns
    document.querySelectorAll('.navmenu .toggle-dropdown').forEach(navmenu => {
      navmenu.addEventListener('click', function(e) {
        e.preventDefault();
        this.parentNode.classList.toggle('active');
        this.parentNode.nextElementSibling.classList.toggle('dropdown-active');
        e.stopImmediatePropagation();
      });
    });

    // Scroll effects
    const toggleScrolled = () => {
      const selectBody = document.querySelector('body');
      const selectHeader = document.querySelector('#header');
      if (!selectHeader.classList.contains('scroll-up-sticky') && 
          !selectHeader.classList.contains('sticky-top') && 
          !selectHeader.classList.contains('fixed-top')) return;
      window.scrollY > 100 ? selectBody.classList.add('scrolled') : selectBody.classList.remove('scrolled');
    };

    const toggleScrollTop = () => {
      const scrollTop = document.querySelector('.scroll-top');
      if (scrollTop) {
        window.scrollY > 100 ? scrollTop.classList.add('active') : scrollTop.classList.remove('active');
      }
    };

    window.addEventListener('scroll', toggleScrolled);
    window.addEventListener('scroll', toggleScrollTop);
    window.addEventListener('load', toggleScrolled);
    window.addEventListener('load', toggleScrollTop);

    // Scroll top button
    const scrollTopBtn = document.querySelector('.scroll-top');
    if (scrollTopBtn) {
      scrollTopBtn.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    }

    // Preloader
    // const preloader = document.querySelector('#preloader');
    // if (preloader) {
    //   window.addEventListener('load', () => {
    //     preloader.remove();
    //   });
    // }

  }, []);

  return (
    <Router>
      <div className="App">
        {/* <Preloader /> */}
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/service-details/:id" element={<ServiceDetails />} />
          <Route path="/productdetails/:id" element={<ProductDetail />} />

        </Routes>
        <Footer />
        <ScrollTop />
      </div>
    </Router>
  );
}

export default App;